import { Box } from "@radix-ui/themes";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import { useFetch } from "../../../../hooks/useFetch";
import { useAppStore } from "../../../../stores/RootStore";
import { FShift, UserCompact } from "../../../../types/types";
import { ScrollArea } from "../../../../ui/ScrollArea/ScrollArea";
import { Separator } from "../../../../ui/Separator";
import Spinner from "../../../../ui/Spinner/Spinner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../../ui/Tabs/Tabs";
import UserSettingsTab from "./tabs/UserSettingsTab";

const UserItem = ({id}:{id: string}) => {
  const [{ response, isLoading, error }, doFetchCurrentItem] = useFetch(`/users/${id}`);
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState<UserCompact>();

  useEffect(() => {
    if (!id) {
      return;
    }
    setLoading(true);
    doFetchCurrentItem();
  }, [id]);

  useEffect(() => {
    if (!response) {
      return;
    }
    const responseData = response.data as unknown as UserCompact;
    setCurrentUser(responseData);
    setLoading(false);
  }, [response]);

  return loading ? (
    <Spinner />
  ) : (
    <UserSettingsTab id={id} currentUser={currentUser} />
  );
};

export default UserItem;
